/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import './_jquery.js';
import "chosen-js";
import "bootstrap-3-typeahead";

window.$ = window.jQuery = jQuery;
jQuery.fn.outerHTML = function(s) {
    return s
        ? this.before(s).remove()
        : jQuery("<div />").append(this.eq(0).clone()).html();
};
